module.exports = __webpack_public_path__ + "static/media/newsletter.267a2c97.png";